import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import NanoClamp from "nanoclamp";
import React from "react";
import { Card, CardBody, CardSubtitle, CardText, CardTitle } from "reactstrap";

const PostArticlesEntry = ({
  post: { id, postId, title, excerpt, author, multipleAuthorsAcf, featuredImage, date, categories, slug },
}) => {
  // format the author name
  const authorName =
    multipleAuthorsAcf && multipleAuthorsAcf.multipleAuthor ? "Multiple Contributors" : author.node.name;
  // get cats
  let cats = [];
  if (categories && categories.nodes) {
    cats = categories.nodes;
  }
  // eslint-disable-next-line no-undef
  const temp = typeof document !== "undefined" ? document.createElement("div") : {};
  temp.innerHTML = excerpt;
  const excerptFmt = temp.textContent || temp.innerText || "";
  // get the cat
  let cat = "";
  if (cats) {
    // first cat != featured
    cat = cats.find((c) => c.name.toLowerCase() !== "featured");
  }
  return (
    <Card className="archive-card h-100" data-id={id} id={`post-preview-${postId}`}>
      <Link to={`/resources/${slug}/`}>
        <GatsbyImage
          image={featuredImage.node.localFile.childImageSharp.archive}
          loading="lazy"
          imgClassName="img-fluid"
          alt={`${featuredImage.node.altText ? featuredImage.node.altText : `Featured Image: ${title}`}`}
        />
      </Link>
      <CardBody>
        <Link to={`/resources/${slug}/`}>
          <CardTitle className="entry-title">{title}</CardTitle>
        </Link>
        <CardSubtitle className="mt-2">
          <NanoClamp className="custom-class" lines={2} text={excerptFmt} />
        </CardSubtitle>
        <CardText tag="div">
          {authorName}
          <br />
          {cat && (
            <>
              <h6 className="cat">{cat.name}</h6>
              <span> - </span>
            </>
          )}
          {date}
        </CardText>
      </CardBody>
    </Card>
  );
};

export default PostArticlesEntry;
